import type { ExternalToast } from "sonner";

// 같은 id 로 다시 띄우면 sonner 가 옛 설명·버튼을 이어 붙인다 — 비는 칸도 undefined 로 적어 덮는다.
export const SHEET_COMMIT_TOAST = "sheet-commit";

export const slotToast = (
  id: string | undefined,
  description?: string,
  action?: ExternalToast["action"]
): Pick<ExternalToast, "id" | "description" | "action"> => ({ id, description, action });
